import {
  QUESTIONPROMPTS_REQUEST,
  QUESTIONPROMPTS_SUCCESS,
  QUESTIONPROMPTS_FAILURE,
  QUESTIONPROMPT_CREATE_FAILURE,
  QUESTIONPROMPT_CREATE_REQUEST,
  QUESTIONPROMPT_CREATE_SUCCESS,
  QUESTIONPROMPT_UPDATE_REQUEST,
  QUESTIONPROMPT_UPDATE_SUCCESS,
  QUESTIONPROMPT_UPDATE_FAILURE,
  QUESTIONPROMPT_DELETE_REQUEST,
  QUESTIONPROMPT_DELETE_SUCCESS,
  QUESTIONPROMPT_DELETE_FAILURE,
} from "../types/questionPrompts.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const QuestionPromptReducer = (state = initialState, action) => {
  switch (action.type) {
    case QUESTIONPROMPTS_REQUEST:
      return {
        ...state,
        storeItemResponse: "",
        loading: true,
      };
    case QUESTIONPROMPTS_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case QUESTIONPROMPTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default QuestionPromptReducer;



const initialCreateState = {
  createResponse: "",
  error: "",
  loading: false,
};

const QuestionPromptCreateReducer = (state = initialCreateState, action) => {
  switch (action.type) {
    case QUESTIONPROMPT_CREATE_REQUEST:
      return {
        ...state,
        createResponse: "",
        loading: true,
      };
    case QUESTIONPROMPT_CREATE_SUCCESS:
      return {
        ...state,
        createResponse: action.payload,
        loading: false,
      };
    case QUESTIONPROMPT_CREATE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};



export { QuestionPromptCreateReducer };


export const questionPromptUpdateReducer = (state = initialCreateState, action) => {
  switch (action.type) {
    case QUESTIONPROMPT_UPDATE_REQUEST:
      return {
        ...state,
        createResponse: "",
        loading: true,
      };
    case QUESTIONPROMPT_UPDATE_SUCCESS:
      return {
        ...state,
        createResponse: action.payload,
        loading: false,
      };
    case QUESTIONPROMPT_UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};


const initialDeleteState = {
  deleteResponse: "",
  error: "",
  loading: false,
}

export const questionPromptDeleteReducer = (state = initialDeleteState, action) => {
  switch (action.type) {
    case QUESTIONPROMPT_DELETE_REQUEST:
      return {
        ...state, 
        deleteResponse: "",
        loading: true,
      };
    case QUESTIONPROMPT_DELETE_SUCCESS:
      return {
        ...state,
        deleteResponse: action.payload,
        loading: false,
      };
    case QUESTIONPROMPT_DELETE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
    }
};